// /////////////////////////////////////////////////////////////
// [ファイル] SalesProjectTypeChip.tsx
// [概要] 案件種別（仕入 / 売上 / 未分類）を色分け Chip で表示
// /////////////////////////////////////////////////////////////
import React from 'react';
import { Chip, ChipProps, SxProps, Theme } from '@mui/material';
import { PROJECT_TYPE_COLORS, PROJECT_TYPE_LABELS } from '../constants/masterData';

interface SalesProjectTypeChipProps {
  type: string | null | undefined;
  size?: ChipProps['size'];
  sx?: SxProps<Theme>;
}

export default function SalesProjectTypeChip({ type, size = 'small', sx }: SalesProjectTypeChipProps) {
  const isUnclassified = !type;
  const color = PROJECT_TYPE_COLORS[isUnclassified ? 'unclassified' : type!] ?? PROJECT_TYPE_COLORS.unclassified;
  return (
    <Chip
      label={isUnclassified ? '未分類' : (PROJECT_TYPE_LABELS[type!] ?? type)}
      size={size}
      variant={isUnclassified ? 'outlined' : 'filled'}
      sx={{
        bgcolor: isUnclassified ? 'transparent' : color.bg,
        color: color.fg,
        borderColor: isUnclassified ? color.fg : undefined,
        borderStyle: isUnclassified ? 'dashed' : undefined,
        fontWeight: 600,
        fontSize: '0.75rem',
        borderRadius: '6px',
        height: 22,
        '& .MuiChip-label': { px: 1 },
        ...sx,
      }}
    />
  );
}
